'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var ThreadPreviewRecord = (0, _immutable.Record)({
  hasFileAttachment: false
});

exports.default = ThreadPreviewRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-preview/records/ThreadPreviewRecord.js
// module id = 875
// module chunks = 2 3